import type { ReactNode } from "react";

import { NavigationMenu, NavigationMenuList } from "../../../ui/navigation-menu";

export const NavRight = ({
  popup,
  children,
}: {
  popup: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div className="flex flex-row items-center">
      <NavigationMenu orientation="vertical" align="right">
        <NavigationMenuList>
          {children}
          {popup}
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};
